<script>

  import {API_USER} from '../../common/api'
  import VillageSelect from '../../components/VillageSelect'
  import {getFirstNode, rangeVillage} from '../../assets/js/funcs'

  export default {
    name: 'UserUpdate',
    props: ["user_id"],
    data() {
      return {
        userForm: {
          id: 0,
          name: '',
          mobile: '',
          village_id: 0,
          house: '',
          last_amount: '',
          now_amount: '',
          balance: '',
          is_pay: 0,
          remark: ''
        },
        user_number: '',
        rules: {
          house: [
            {required: true, message: '门牌号不能为空', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ],
          village_id: [
            {required: true, message: '所属小区不能为空', trigger: 'blur'}
          ],
          last_amount: [
            {required: true, message: '表单数不能为空', trigger: 'blur'}
          ],
          now_amount: [
            { required: true, message: '抄表数不能为空', trigger: 'blur' }
          ],
          balance: [
            {required: true, message: '账户余额不能为空', trigger: 'blur'}
          ]
        },
        isLoading: false,
        optionProps: {
          value: 'id',
          label: 'name',
          expandTrigger: 'hover'
        },
      }
    },
    created() {
      this.selectUser()
    },
    methods: {
      selectUser() {
        this.isLoading = true;
        this.$http.GET(API_USER + '/' + this.user_id, null,
          res => {
            this.userForm = res.result.data;
            if (res.result.data) {
              this.user_number = res.result.data.number
            }
            this.isLoading = false
          }, err => {
            this.$message.error(err.msg);
            this.isLoading = false
          })
      },
      selectVillage(data) {
        this.userForm.village_id = data
      },
      updateUser(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true;
            this.$http.PUT(API_USER + '/' + this.user_id, this.userForm,
              res => {
                this.isLoading = false;
                this.$emit('updateSuccess')
              }, err => {
                this.isLoading = false;
                this.$message.error(err.msg)
              })
          }
        })
      },

      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    components: {
      VillageSelect
    }
  }
</script>

<template>
  <div>
    <el-form v-loading="isLoading" ref="userForm" :model="userForm" :rules="rules" size="small" @submit.native.prevent
             label-width="100px">
      <el-form-item label="用户编号" prop="number">
        <el-input v-model="user_number" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="name">
        <el-input v-model="userForm.name" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="userForm.mobile" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="所属小区" prop="village_id">
        <VillageSelect @selectVillageId='selectVillage' :defaultVillageId='this.userForm.village_id'
                       style="width: 350px"></VillageSelect>
      </el-form-item>
      <el-form-item label="门牌号" prop="house">
        <el-input v-model="userForm.house" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="表单数" prop="last_amount">
        <el-input v-model="userForm.last_amount" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="抄表数" prop="now_amount">
        <el-input v-model="userForm.now_amount" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="账户余额" prop="balance">
        <el-input v-model="userForm.balance" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="是否缴费" prop="is_pay">
        <el-radio-group v-model="userForm.is_pay">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="备注"
          v-model="userForm.remark">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('userForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="updateUser('userForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/user/UserUpdate.vue